// extracted by mini-css-extract-plugin
module.exports = {"root":"e_ftb","panel":"e_gtb"};